export const EVENT_SUMMARY_SECTION_WIDTH = '440px';
export const UNITS_PILL_TRUNCATE_COUNT = 5;
